import { AdvizeApi } from "@/api/api";
import { Analytics } from "./Analytics";
import { PlaylistService } from "./PlaylistService";
import { UserProfileService } from "./UserProfileService";
import { RealtimeDatabase } from "./RealtimeDatabase";

interface GetRecommendedPlaylistsParams {
  userProfileData?: any;
  customRequest?: string | null;
  includeAllUserProfileData?: boolean;
  userId: string;
}

interface GetRecommendedAdvizersParams {
  userId: string;
}

class RecommendationServiceClass {
  constructor() {}

  async getRecommendedPlaylists({
    userProfileData,
    customRequest,
    includeAllUserProfileData = false,
    userId,
  }: GetRecommendedPlaylistsParams) {
    const startTime = Date.now();

    PlaylistService.clearUserRecommendedPlaylists();
    RealtimeDatabase.setIsRequestionPlaylistRecs(true);

    Analytics.getRecommendedPlaylists({
      inputValue: customRequest || undefined,
    });

    const playlistRecommendations = await AdvizeApi.recommendPlaylists({
      userProfileData,
      customRequest,
      includeAllUserProfileData,
      userId,
    });

    const duration = Date.now() - startTime;
    if (duration > 5000) {
      console.error(`Playlist recommendations took too long: ${duration}ms`);
      Analytics.playlistError({
        error: "Playlist recommendations took too long",
        playlist: null,
        value: duration || -1,
      });
    }

    // Check if recommendations are empty or invalid
    if (!playlistRecommendations || playlistRecommendations.length === 0) {
      Analytics.playlistError({
        error: "No playlist recommendations were returned",
        playlist: null,
        value: duration || -1,
      });
    }

    PlaylistService.updateUserRecommendedPlaylists(
      playlistRecommendations || [],
    );

    return playlistRecommendations;
  }

  async getRecommendedAdvizers(params: GetRecommendedAdvizersParams) {
    const startTime = Date.now();

    RealtimeDatabase.clearUserRecommendedAdvizers();
    RealtimeDatabase.setIsRequestionAdvizerRecs(true);

    Analytics.getRecommendedAdvizers();

    const advizerRecommendations = await AdvizeApi.recommendAdvizers(params);

    console.log("\n\nadvizerRecommendations", advizerRecommendations);

    const duration = Date.now() - startTime;
    if (duration > 30 * 1000) {
      console.error(`Advizer recommendations took too long: ${duration}ms`);
      Analytics.advizerRecommendationsError({
        error: "Advizer recommendations took too long",
        value: duration || -1,
      });
    }

    // Check if recommendations are empty or invalid
    if (!advizerRecommendations || advizerRecommendations.length === 0) {
      Analytics.advizerRecommendationsError({
        error: "No advizer recommendations were returned",
        value: duration || -1,
      });
    }

    UserProfileService.updateUserRecommendedAdvizers(
      advizerRecommendations || [],
    );

    return advizerRecommendations;
  }
}

export const RecommendationService = new RecommendationServiceClass();
